import React from "react";

// CSS/SVG-driven 3D animated logo — rotating gyroscopic rings + glowing core.
export default function Logo3D({ size = 140 }) {
  return (
    <div
      className="scene-3d animate-float relative"
      style={{ width: size, height: size }}
      data-testid="logo-3d"
    >
      <div className="orb relative" style={{ width: size, height: size }}>
        <div className="ring" style={{ transform: "rotateY(0deg)" }} />
        <div className="ring" style={{ transform: "rotateY(60deg)", borderColor: "rgba(255,184,0,0.5)" }} />
        <div className="ring" style={{ transform: "rotateY(120deg)" }} />
      </div>
      <div
        className="absolute animate-pulse-glow"
        style={{
          left: "50%", top: "50%", width: size * 0.32, height: size * 0.32,
          transform: "translate(-50%,-50%)", borderRadius: "50%",
          background: "radial-gradient(circle, #00E5FF 0%, rgba(0,229,255,0.2) 60%, transparent 70%)",
          boxShadow: "0 0 40px rgba(0,229,255,0.7)",
        }}
      />
    </div>
  );
}
